import { OrderItemFragment } from '@src/queries/OrderDetailsQuery.generated'
import { OrderItemScheduleLine } from '@src/types/graphql-types'
import { getOrderItemsStatusKey } from '../OrderDetail/orderDetailUtils'

export interface MergedOrderItemScheduleLine extends OrderItemScheduleLine {
  routeInfo?: string | null
}

export interface OrderItemFragmentWithMergedLines extends OrderItemFragment {
  scheduleLines: MergedOrderItemScheduleLine[]
}

const checkForSameScheduleLineAndMerge = (itemGroup: OrderItemFragment[]) => {
  const scheduleLines: MergedOrderItemScheduleLine[] = itemGroup
    .map((item) =>
      item.scheduleLines.map((line) => ({ ...line, routeInfo: item.routeInfo }))
    )
    .flat()

  const scheduleLineGroups: { [key: string]: MergedOrderItemScheduleLine } = {}

  scheduleLines.forEach((line) => {
    const key = [
      line.confirmedQuantity ? 'hasQty' : 'noQty',
      line.status && getOrderItemsStatusKey(line.status),
      line.displayableDate,
      line.trackingInfo.map((info) => info.estimatedDeliveryDate).join(',') ||
        line.routeInfo,
      line.trackingInfo.map((info) => info.trackingNumber).join(','),
    ].join('-')

    const group = scheduleLineGroups[key]
    if (group) {
      if (group.confirmedQuantity && line.confirmedQuantity) {
        group.confirmedQuantity += line.confirmedQuantity
      }
    } else {
      scheduleLineGroups[key] = { ...line }
    }
  })

  return Object.values(scheduleLineGroups)
}

export const groupOrderItems = (
  items: OrderItemFragment[]
): OrderItemFragmentWithMergedLines[] => {
  const groups: { [key: string]: OrderItemFragment[] } = {}
  items.forEach((item) => {
    const { materialNumber, configurationId } = item
    let key = `${materialNumber}`

    if (configurationId) {
      key += `-${configurationId}`
    }

    if (!groups[key]) {
      groups[key] = []
    }
    groups[key].push(item)
  })

  return Object.values(groups).map((itemGroup) => {
    return {
      ...itemGroup[0],
      scheduleLines: checkForSameScheduleLineAndMerge(itemGroup),
    }
  })
}
